import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CompaniesDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
	company_id: any = [];
  companyList: any = [];
  businessList: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  name: string = "";
  manager: string = "";
  allowedUsers: string = "";
  company: string = "";
  permissions: string = "";
  companies: string = "";
  businessName: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  logo: string = "";

  mounted (){
    const _ = this;
    _.getByCompany();
    _.filterDate();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getByCompany(){
    const _ = this;
    _.company_id = location.href.split("/");
    _.company_id = _.company_id[5];
    _.isLoading = true;
    _.detailService.getByCompany(_.company_id).then((data: any) => {
      console.log(data);
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].company.name;
      _.logo = data["data"].company.logo;
      _.manager = data["data"].company.manager;
      _.businessName = data["data"].company.business.name;
      _.createdAt = data["data"].company.createdAt;
      _.updatedAt = data["data"].company.updatedAt;
      console.log(_.updatedAt)
      _.allowedUsers = data["data"].company.allowedUsers;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
